export const BLOCKPAGE_PAGEUI_UPDATE = 'BLOCKPAGE_PAGEUI_UPDATE';
export const BLOCKPAGE_BLOCKUI_UPDATE = 'BLOCKPAGE_BLOCKUI_UPDATE';

export const SET_PAGE_FAVOURITED = 'SET_PAGE_FAVOURITED';
export const SET_PAGE_SUBSCRIBED_ACTION_TYPES =
  'SET_PAGE_SUBSCRIBED_ACTION_TYPES';

export const SET_PAGE_TRAVERSAL_LINKS = 'SET_PAGE_TRAVERSAL_LINKS';
export const SET_PAGE_DISPLAY_OPTIONS = 'SET_PAGE_DISPLAY_OPTIONS';

export const SET_COMMUNITY_OPTIONS = 'SET_COMMUNITY_OPTIONS';

export const BLOCKPAGE_DATA_LOADED_SUCCESS = 'BLOCKPAGE_DATA_LOADED_SUCCESS';
export const BLOCKPAGE_OPEN_SHARE_MODAL = 'BLOCKPAGE_OPEN_SHARE_MODAL';
export const BLOCKPAGE_CLOSE_SHARE_MODAL = 'BLOCKPAGE_CLOSE_SHARE_MODAL';

export const BLOCKPAGE_UNMOUNT = 'BLOCKPAGE_UNMOUNT';

export const SET_BLOCKPAGE_UI_MODE = 'SET_BLOCKPAGE_UI_MODE';

export const SET_IS_COMMENT_REQUIRED_START = 'SET_IS_COMMENT_REQUIRED_START';
export const SET_IS_COMMENT_REQUIRED_SUCCESS =
  'SET_IS_COMMENT_REQUIRED_SUCCESS';
export const SET_IS_COMMENT_REQUIRED_FAILURE =
  'SET_IS_COMMENT_REQUIRED_FAILURE';
